
const aktuelltData = [
  {
    id: 1,
    typ: "Webbsändning",
    titel: "Räkna med mig medverkade i webbsändning hos MUCF",
    beskrivning: "Räkna med mig deltog som en programpunkt i en webbsändning från Myndigheten för ungdoms- och 	civilsamhällesfrågor (MUCF). Ta del av sändningen och få en inblick i projektets arbete med att skapa fler 	möjligheter för unga.",
    datum: "2026-10-09",
    url: "https://www.youtube.com/live/7M7m6MyMdJM?reload=9 ",
    prioritet: "Nyhet",
    aktiv: true,
    knappText: "Se webbsändningen",
  },
  {
  id: 2,
  typ: "Dokument",
  titel: "Slutrapport hösten 2026",
  beskrivning: "Ta del av rapporten i PDF-format.",
  datum: "2026-10-12",
  url: "Slutrapport hösten 2026.pdf",
  prioritet: "Nyhet",
  aktiv: true,
  knappText: "Läs PDF"
}
];

export default aktuelltData;

